'use client';

import layoutStyles from '@/styles/modules/layout.module.scss';
import { useRouter } from 'next/navigation';
import type React from 'react';
import { useState } from 'react';
import ActionButton from '../../../../components/form/ActionButton/ActionButton';
import UnRegisteredAddressAlert from '../../../../components/ui/UnRegisteredAddressAlert/UnRegisteredAddressAlert';
import RepostPrizeList from '../../../../features/lottery/components/RepostPrizeList.tsx/RepostPrizeList';
import { swal } from '../../../../lib/sweetalert';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { pickErrorMessages } from '../../../../utils/functions';
import type { PostRepostCampaignAchieveParams } from '../../api/postRepostCampaignAchieve';
import type { PostRepostCampaignAchieveParams as PostRepostCampaignAchieveV2Params } from '../../api/v2/postRepostCampaignAchieve';
import { DELIVERY_VERSION } from '../../constants';
import type { RepostCampaignDetail } from '../../types';

import styles from './RepostCampaignPreview.module.scss';

type RepostCampaignPreviewProps = {
  campaignDetail: RepostCampaignDetail;
  code: string;
  version?: string | null;
  postRepostCampaignAchieve: ({ code }: PostRepostCampaignAchieveParams) => Promise<void>;
  postRepostCampaignAchieveV2: ({ code }: PostRepostCampaignAchieveV2Params) => Promise<void>;
  handleGoMainAddress: (e: React.MouseEvent) => void;
};

function RepostCampaignPreview({
  campaignDetail,
  code,
  version = null,
  postRepostCampaignAchieve,
  postRepostCampaignAchieveV2,
  handleGoMainAddress,
}: RepostCampaignPreviewProps) {
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();
  const handleReceiveCampaignPrize = async () => {
    try {
      if (isLoading) return;
      setIsLoading(true);
      if (version === DELIVERY_VERSION.v2.value) {
        await postRepostCampaignAchieveV2({
          code: code,
        });
      } else {
        await postRepostCampaignAchieve({
          code: code,
        });
      }
      swal.alert({ text: '景品を受け取りました' });
      router.push('/account/collection');
    } catch (error) {
      await swal.messages({ messages: pickErrorMessages(error) });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.componentStyle}>
      <RepostPrizeList items={[campaignDetail.prize]} />
      {!campaignDetail.setAddress && (
        <div className={utilsStyles.mtSmall}>
          <UnRegisteredAddressAlert handleGoMainAddress={handleGoMainAddress} />
        </div>
      )}
      <div className={`${utilsStyles.mtSmall} ${layoutStyles.centeredBtnWrapper}`}>
        <ActionButton
          onClick={handleReceiveCampaignPrize}
          disabled={isLoading || !campaignDetail.setAddress}
          isLoading={isLoading}
          color='primary'
        >
          景品を受け取る
        </ActionButton>
      </div>
    </div>
  );
}

export default RepostCampaignPreview;
